import { Data } from '../form/form.model';

import {
    HierarchyInfo,
    ManagerReportDataItem,
    Metadata,
    PayloadExtended,
} from './tdcf.model';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const storeStateMapper = (state: any) => state.tdcfForm;

export interface TableState {
    me?: Array<Data<PayloadExtended>>;
    team?: Array<Data<PayloadExtended>>;
}

export interface FormState {
    pending?: boolean;
    payload?: PayloadExtended;
    formValue?: any;
    readonly?: boolean;
}

export interface PrintPreviewState {
    pending?: boolean;
    metadata?: Metadata;
    payload?: PayloadExtended;
}

export interface ManagerReportState {
    pendingMetadata?: boolean;
    pendingData?: boolean;
    metadata?: Metadata;
    formValue?: any;
    table?: ManagerReportTableState;
}

export interface ManagerReportTableState {
    data?: ManagerReportDataItem[];
}

export interface State {
    pending?: boolean;
    metadata?: Metadata;
    info?: HierarchyInfo;
    hierarchy?: HierarchyInfo;
    table: TableState;
    form: { [key: string]: FormState };
    printPreview: PrintPreviewState;
    managerReport: ManagerReportState;
}

export const defaultState = (): State => ({
    table: {},
    form: { MEMBER: { readonly: true }, MANAGER: { readonly: true } },
    printPreview: {},
    managerReport: {},
});
